import { AfterContentInit, Component, Input } from '@angular/core';
import { BaseTableTemplate } from './base/base-table-template';

@Component({
  selector: 'app-column',
  template: ''
})
export class DatatableColumnComponent extends BaseTableTemplate implements AfterContentInit {
  @Input() field: string | 'numId' | 'keywordList';
  @Input() type: 'number' | 'currency' | 'date';
  @Input() colId: string;
  @Input() sortField: string;
  @Input() sortable: any;
  @Input() rowspan: number;
  @Input() colspan: number;
  @Input() scope: string;
  @Input() width: string;
  @Input() style: any;
  @Input() styleClass: string;
  @Input() header: string;
  @Input() headerStyle: any;
  @Input() headerStyleClass: string;
  @Input() bodyStyle: any;
  @Input() bodyStyleClass: string;
  // @Input() footer: string;
  // @Input() footerStyle: any;
  // @Input() footerStyleClass: string;

  ngAfterContentInit(): void {
    super.ngAfterContentInit();
  }

}
